<template>
    <div class="bo_comment_box">
        <div class="bo_comment_tit">
            <img src="@/assets/user/comment_ico.png" alt="">
            <span>댓글 [ <b>{{ $props.cntComment }}</b>건 ]</span>
        </div>
        <div class="bo_comment">
            <ul>
                <li v-for="(item, idx) in comment.data" :data-list="`comment` + item.idx">
                    <div class="comment_info">
                        <div>
                            <span class="user_id">{{ item.name }} [{{ item.childCnt }}건]</span>
                            <span class="write_date">
                                {{ item.updateDate ?
                                    formatDate(item.updateDate) :
                                    formatDate(item.createDate) }}
                            </span>
                        </div>
                        <button type="button" class="comment_info_btn" @click="showModifyBtn(item.idx)"
                            v-if="item.meIdx === user.userInfo.idx && item.state === 1">
                            <i></i>
                            <i></i>
                            <i></i>
                        </button>
                        <div class="comment_modify_box"
                            :style="comment.isModifyBox[item.idx] ? 'display:block' : 'display: none;'">
                            <button type="button" class="modify_btn" @click="modifyComment(item.idx, idx)">수정</button>
                            <span></span>
                            <button type="button" class="modify_btn" @click="deleteCommentBtn(item.idx)">삭제</button>
                        </div>
                    </div>
                    <div class="comment_content">
                        <div class="cc_tit">
                            <template v-if="item.state === 0">
                                <p>관리자에 의해 삭제된 댓글입니다.</p>
                            </template>
                            <template v-if="item.state === 1">
                                <p>{{ item.content }}</p>

                            </template>
                            <template v-if="item.state === 2">
                                <p>사용자에 의해 삭제된 댓글입니다.</p>
                            </template>
                            <button type="button" class="write_reply_btn" @click="showReCommentInput(idx)"
                                v-if="item.state === 1">댓글달기</button>
                        </div>
                        <div class="cc_good_bad_btns">
                            <button type="button" class="good_btn" @click="commentGood(item.idx, idx)">
                                <img src="@/assets/user/good_ico.png" alt="">
                                <span>{{ item.cntGood }}</span>
                            </button>
                            <button type="button" class="bad_btn" @click="commentBad(item.idx, idx)">
                                <img src="@/assets/user/bad_ico.png" alt="">
                                <span>{{ item.cntBad }}</span>
                            </button>
                        </div>
                    </div>
                    <div class="reply_box">
                        <ul>
                            <template v-for="(reItem, reIdx) in reComment.data[idx]">
                                <li v-if="reItem.parentIdx === item.idx">
                                    <div class="reply_ico">
                                        <img src="@/assets/user/reply_ico.png" alt="">
                                    </div>
                                    <div class="comment_info">
                                        <div>
                                            <span class="user_id">{{ reItem.name }}</span>
                                            <span class="write_date">
                                                {{ reItem.updateDate ?
                                                    formatDate(reItem.updateDate) :
                                                    formatDate(reItem.createDate) }}
                                            </span>
                                        </div>
                                        <button type="button" class="comment_info_btn"
                                            @click="showReModifyBtn(reItem.idx)"
                                            v-if="reItem.meIdx === user.userInfo.idx && reItem.state === 1">
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                        </button>
                                        <div class="comment_modify_box" :id="'reComment' + reItem.idx">
                                            <button type="button" class="modify_btn"
                                                @click="modifyReComment(idx, reIdx)">수정</button>
                                            <span></span>
                                            <button type="button" class="modify_btn"
                                                @click="deleteCommentBtn(reItem.idx)">삭제</button>
                                        </div>
                                    </div>
                                    <div class="comment_content">
                                        <div class="cc_tit">
                                            <template v-if="reItem.state === 0">
                                                <p>관리자에 의해 삭제된 댓글입니다.</p>
                                            </template>
                                            <template v-if="reItem.state === 1">
                                                <p>{{ reItem.content }}</p>

                                            </template>
                                            <template v-if="reItem.state === 2">
                                                <p>사용자에 의해 삭제된 댓글입니다.</p>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                        <div class="reply_more_btn" v-if="reComment.isMoreReComment[idx]">
                            <button type="button" @click="getReComment(item.idx, idx)">더보기</button>
                        </div>
                        <div class="reply_write_box" :style="comment.isReCommentBox[idx] ? 'display:block' : ''">
                            <div class="reply_input_box">
                                <span><img src="@/assets/user/reply_ico.png" alt=""></span>
                                <input type="text" :id="'reCommentWrite' + idx"
                                    @keydown.enter="addReCommentBtn(item.idx, idx)">
                                <button type="button" @click="addReCommentBtn(item.idx, idx)"
                                    v-if="reComment.isBtnType === 0">등록</button>
                                <button type="button" @click="modifyReCommentBtn(idx)" v-else>수정</button>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="bo_comment_write">
            <p>댓글 작성</p>
            <div class="comment_write_input">
                <input type="text" v-model="comment.myComment" id="commentWrite">
                <button type="button" @click="addComment" v-if="comment.isBtnType === 0">등록</button>
                <button type="button" @click="modifyCommentBtn()" v-else>수정</button>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>
<script lang="ts">
import {
    apiService,
    reactive,
    ModalComponent,
    onMounted,
    formatDate,
    userStore,
    sortListDate
} from '@/BaseComponent';

export default {
    props: [
        "contentIdx",
        "cntComment",
    ],
    components: {
        ModalComponent,
    },
    setup(props: any, { emit }: any) {
        const user = userStore() as any;
        const state = reactive({
            contentIdx: props.contentIdx as string,
            isModalOpen: false as boolean,
            isCommentMenu: false as boolean,
            isReCommentMenu: false as boolean,
            isShowReComment: false as boolean,
        });
        const comment = reactive({
            modifyIdx: 0 as number,
            myComment: "" as string,
            pageNum: 1 as number,
            size: 100 as number,
            data: {} as any,
            isBtnType: 0 as number, // 0 등록 , 1 수정
            isModifyBox: [] as Array<boolean>,
            isReCommentBox: [] as Array<boolean>,
            isLikeBtn: [] as Array<boolean>,
            isBadBtn: [] as Array<boolean>,
            isMyComment: false as boolean,
        });
        const reComment = reactive({
            modifyIdx: 0 as number,
            commentIdx: 0 as number,
            myComment: "" as string,
            pageNum: [] as Array<number>,
            size: 5 as number,
            data: [] as any,
            isWriteBox: false as boolean,
            isModifyBox: false as boolean,
            isBtnType: 0 as number,
            isMoreReComment: [] as Array<boolean>,
        });
        const modal = reactive({
            confirm: "" as string,
            cancel: "" as string,
            content: "" as string,
            actionCode: 0 as number,
            tempData: "" as any
        });

        onMounted(() => {
            getComment(state.contentIdx);
        });

        const addReCommentBtn = (commentIdx: number, idx: number) => {
            state.isModalOpen = true;
            modal.content = "댓글 등록을 하시겠습니까?";
            modal.confirm = "확인";
            modal.cancel = "취소";
            modal.actionCode = 1;
            comment.modifyIdx = commentIdx;
            reComment.modifyIdx = idx;
        };
        const modifyCommentBtn = () => {
            state.isModalOpen = true;
            modal.content = "댓글 수정을 하시겠습니까?";
            modal.confirm = "확인";
            modal.cancel = "취소";
            modal.actionCode = 3;
        };
        const modifyReCommentBtn = (idx: number) => {
            const tempText = document.getElementById("reCommentWrite" + idx) as HTMLInputElement;
            reComment.myComment = tempText.value;
            state.isModalOpen = true;
            modal.content = "댓글 수정을 하시겠습니까?";
            modal.confirm = "확인";
            modal.cancel = "취소";
            modal.actionCode = 4;
        };

        const deleteCommentBtn = (idx: number) => {
            state.isModalOpen = true;
            modal.content = "댓글을 삭제하시겠습니까?";
            modal.confirm = "확인";
            modal.cancel = "취소";
            modal.actionCode = 2;
            comment.modifyIdx = idx;
        };


        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:// 대댓글 등록
                        addReCommentApi(comment.modifyIdx, reComment.modifyIdx);
                        modal.actionCode = 0;
                        break;
                    case 2:// 댓글 삭제
                        deleteCommentApi(comment.modifyIdx);
                        modal.actionCode = 0;
                        break;
                    case 3:// 댓글 수정
                        modifyCommentApi(comment.modifyIdx, comment.myComment);
                        modal.actionCode = 0;
                        break;
                    case 4:// 대댓글 수정
                        modifyCommentApi(reComment.modifyIdx, reComment.myComment);
                        modal.actionCode = 0;
                        break;
                }
            } else {
                switch (modal.actionCode) {
                    case 1:
                        getComment(state.contentIdx);
                        modal.actionCode = 0;
                        break;
                    case 5:// 페이지 새로고침
                        location.reload();
                        modal.actionCode = 0;
                        break;

                }
            }
        };

        // API호출 함수
        const getComment = async (idx: string) => {
            const res = await apiService.community.getComment(idx, comment.pageNum, comment.size);
            if (res.returnCode === 0) {
                comment.data = res.data.data;
                sortListDate(comment.data);
                for (let i = 0; i < res.data.data.length; i++) {
                    comment.isModifyBox.push(false);
                    comment.isReCommentBox.push(false);
                    comment.isLikeBtn.push(res.data.data[i].isGood);
                    comment.isBadBtn.push(res.data.data[i].isBad);
                    reComment.isMoreReComment[i] = false;
                    if (res.data.data[i].childCnt > 0) {
                        reComment.isMoreReComment[i] = true;
                    }
                }
            }
        };
        const getReComment = async (commentIdx: number, idx: number) => {
            if (reComment.pageNum[idx] === undefined || reComment.pageNum[idx] === 0) {
                reComment.pageNum[idx] = 1;
            }
            const res = await apiService.community.getReComment(commentIdx, reComment.pageNum[idx], reComment.size);
            if (res.returnCode === 0) {
                if (!reComment.data[idx]) {
                    reComment.data[idx] = res.data.data;
                    reComment.pageNum[idx]++;
                } else {
                    for (let i = 0; i < res.data.data.length; i++) {
                        reComment.data[idx].push(res.data.data[i]);
                    }
                    if (res.data.data.length < 5) {
                        reComment.pageNum[idx]++;
                    }
                }
                if (comment.data[idx].childCnt <= reComment.data[idx].length) {
                    reComment.isMoreReComment[idx] = false;
                }
                sortListDate(reComment.data[idx], "up");
            }
        };

        const addComment = async () => {
            if (comment.myComment !== "" || comment.myComment === undefined || comment.myComment === null) {
                const res = await apiService.community.addComment(state.contentIdx, comment.myComment);
                if (res.returnCode === 0) {
                    modal.content = "댓글이 등록되었습니다.";
                    modal.cancel = "확인";
                    modal.confirm = "";
                    modal.actionCode = 1;
                    state.isModalOpen = true;
                    comment.myComment = "";
                } else if (res.returnCode === 5) {
                    modal.content = res.description;
                    modal.cancel = "확인";
                    modal.confirm = "";
                    state.isModalOpen = true;
                }
            } else {
                modal.content = "내용을 입력해주세요";
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            }
        };

        const addReCommentApi = async (commentIdx: number, idx: number) => {
            let reComment = "" as string;
            comment.isReCommentBox[commentIdx] = false;
            const tempText = document.getElementById("reCommentWrite" + idx) as HTMLInputElement;
            if (tempText) {
                reComment = tempText.value;
                tempText.value = "";
            }
            const res = await apiService.community.addReComment(commentIdx, reComment);
            if (res.returnCode === 0) {
                state.isModalOpen = true;
                modal.content = "대댓글이 등록되었습니다.";
                modal.cancel = "확인";
                modal.confirm = "";
                modal.actionCode = 5;

            } else if (res.returnCode === 5) {
                modal.content = "값을 입력해주세요";
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            } else if (res.returnCode === 29) {
                modal.content = res.description;
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            }
        };

        const deleteCommentApi = async (idx: number) => {
            const res = await apiService.community.deleteComment(idx);
            if (res.returnCode === 0) {
                modal.content = "삭제되었습니다.";
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            } else {
                modal.content = res.description;
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            }
        };

        const modifyCommentApi = async (idx: number, editComment: string) => {
            const res = await apiService.community.modifyComment(idx, editComment);
            if (res.returnCode === 0) {
                state.isModalOpen = true;
                modal.content = "수정되었습니다.";
                modal.cancel = "확인";
                modal.confirm = "";
                modal.actionCode = 5;
                comment.isBtnType = 0;
                reComment.isBtnType = 0;
                comment.myComment = "";
                reComment.myComment = "";
            } else {
                modal.content = res.description;
                modal.cancel = "확인";
                modal.confirm = "";
                state.isModalOpen = true;
            }
        };

        const commentGood = async (commentidx: number, idx: number) => {
            const res = await apiService.community.commentGood(commentidx);
            if (res.returnCode === 0) {
                if (comment.isLikeBtn[idx] === true) {
                    comment.data[idx].cntGood--;
                    comment.isLikeBtn[idx] = !comment.isLikeBtn[idx];

                } else if (comment.isLikeBtn[idx] === false) {
                    comment.data[idx].cntGood++;
                    comment.isLikeBtn[idx] = !comment.isLikeBtn[idx];
                }
            }
        };

        const commentBad = async (commentidx: number, idx: number) => {
            const res = await apiService.community.commentBad(commentidx);
            if (res.returnCode === 0) {
                if (comment.isBadBtn[idx] === true) {
                    comment.data[idx].cntBad--;
                    comment.isBadBtn[idx] = !comment.isBadBtn[idx];

                } else if (comment.isBadBtn[idx] === false) {
                    comment.data[idx].cntBad++;
                    comment.isBadBtn[idx] = !comment.isBadBtn[idx];
                }
            }
        };

        const modifyComment = (commentIdx: number, idx: number) => {
            comment.myComment = comment.data[idx].content;
            const commentInput = document.getElementById('commentWrite') as HTMLInputElement || null;
            commentInput?.focus();
            comment.isBtnType = 1;
            comment.modifyIdx = commentIdx;
        };

        const showModifyBtn = (idx: number) => {
            comment.isModifyBox[idx] = !comment.isModifyBox[idx];
        };

        const showReModifyBtn = (idx: number) => {
            const tempText = document.getElementById("reComment" + idx) as HTMLElement;
            if (tempText.style.display === "" || tempText.style.display === "none") {
                tempText.style.display = "block";
            } else if (tempText.style.display === "block") {
                tempText.style.display = "none";
            }

        };

        const showReCommentInput = (idx: number) => {
            comment.isReCommentBox[idx] = !comment.isReCommentBox[idx];
        };

        const modifyReComment = (commentIdx: number, reCommentIdx: number) => {
            const reCommentInput = document.getElementById('reCommentWrite' + commentIdx) as HTMLInputElement || null;
            comment.isReCommentBox[commentIdx] = true;
            reComment.modifyIdx = reComment.data[commentIdx][reCommentIdx].idx;
            reCommentInput.value = reComment.data[commentIdx][reCommentIdx].content;
            reComment.isBtnType = 1;
        };
        return {
            user,
            state,
            comment,
            reComment,
            modal,
            addComment,
            deleteCommentBtn,
            modifyComment,
            modalClose,
            showModifyBtn,
            showReModifyBtn,
            formatDate,
            showReCommentInput,
            getReComment,
            commentBad,
            commentGood,
            addReCommentBtn,
            modifyReComment,
            modifyCommentBtn,
            modifyReCommentBtn,
        };
    }
};
</script>